module.exports = __webpack_public_path__ + "static/media/santi_nuratch.623ed6c3.png";